/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Existing_TrackingInputs */

const en_orders_existing_tracking = /** @type {(inputs: Orders_Existing_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Existing tracking:`)
};

const es_orders_existing_tracking = /** @type {(inputs: Orders_Existing_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracking existente:`)
};

/**
* | output |
* | --- |
* | "Existing tracking:" |
*
* @param {Orders_Existing_TrackingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_existing_tracking = /** @type {((inputs?: Orders_Existing_TrackingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Existing_TrackingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_existing_tracking(inputs)
	return es_orders_existing_tracking(inputs)
});